import Vue from 'vue'
import draggable from 'vuedraggable'
Vue.component('draggable', draggable)
import App from './App.vue'
import router from './router';
import less from 'less'
// import { TUILogin } from '@tencentcloud/tui-core';
// import { framework } from './TUIKit/adapter-vue';
import LightTimeline from "vue-light-timeline";
import Vant, { Lazyload, Toast } from "vant";
import store from '@/store/store'; 
import VueTouch from 'vue-touch'

import "vant/lib/index.css";
import "@/assets/css/base.css";
import "@/assets/css/base.less";
import "@/assets/css/overall.less";
// 桌面端适配 引入模块后自动生效
import '@vant/touch-emulator';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 引入全局自定义指令 图片懒加载
import '@/utils/lazy.js';
import vueFingerDirective from "vue-finger-directive";
// import { tencentConfig } from '@/config/config';
import goToIm from '@/mixins/goToIm';
import myJsTools from './utils/myJsTools';
import { stopLoading, getBrowserInfo  } from '@/utils/public';
import Mixins from './mixins/index.js';
import { createSlsTracker, ErrorCapture } from 'al-sls-web-track';
import { getPlatform } from '@tencentcloud/universal-api';
// main.js

Toast.allowMultiple(true) // 允许多个 Toast 同时存在，解决Loading和接口返回的错误信息会覆盖的问题


let docId = '';
if (myJsTools.getItem('docUserInfo') && myJsTools.getItem('docUserInfo').docId) {
  docId = myJsTools.getItem('docUserInfo').docId;
};
docId && store.dispatch('msg/initWebSocket', docId);


// 通知权限变化埋点
if(navigator.permissions) {
  navigator.permissions.query({ name: "notifications" }).then((res) => {
    const preState = res.state;
    res.onchange = function (e: any) {
      // 通知权限发生变化
      (window as any).$tracker.send({
        message: '#NOTICE#消息提醒-notifications_change-通知权限改变',
        content: JSON.stringify({
          pre_state: preState,
          state: e.target.state
        })
      });
    }
  });
}

// 页面是否可见埋点
document.addEventListener('visibilitychange', function() {
  let isPageVisible = document.visibilityState === 'visible';
  let message = isPageVisible ? '页面切到前台' : '页面切到后台';
  // 获取设备类型（PC/H5）
  let platform = getPlatform() === 'pc' ? 'Web' : 'H5';
  // 获取浏览器品牌信息
  let browserInfo = getBrowserInfo();
  console.log('test--->visibilitychange', message, platform, browserInfo);
  (window as any).$tracker.send({
    message: `#${message}#-visibilitychange`,
    content: JSON.stringify({
      isPageVisible: isPageVisible,
      platform: platform,
      browserInfo
    })
  })
});


Vue.use(goToIm)
Vue.use(ElementUI);
Mixins.forEach(mixin => Vue.mixin(mixin));

Vue.use(VueTouch, {name: 'v-touch'})
VueTouch.config.swipe = {
  threshold: 10 //手指左右滑动距离
}

// 创建追踪器实例
const tracker: any = process.env.VUE_APP_ENV === 'development' ? new Proxy({}, {
  get(target, prop) {
    return function (...args) {
      // console.debug(`Method "${prop}" is called, but does not exist or ignored.`);
      return undefined; // 或 Promise.resolve()
    };
  }
}) : createSlsTracker({
  env: process.env.VUE_APP_LOG_ENV,     // 环境类型：test/pre/prod（必填）
  logstore: 'cloud-hos-h5',            // 日志库名（必填）
  userId: '',                          // 用户ID，将自动添加到所有日志中
  trackerType: 'browser',               // 可选：'browser'（默认）| 'mini'（微信小程序）
  time: 10,                             // 批量发送时间间隔(秒)，默认10
  count: 10,                            // 批量发送数量阈值，默认10
  topic: getPlatform() === 'pc' ? 'web-doctor-log' : 'h5-doctor-log',                     // 日志主题
  source: getPlatform() === 'pc' ? 'web-doctor' : 'h5-doctor',                    // 日志来源
  tags: {                               // 自定义标签
    version: process.env.VUE_APP_BUILD_TIME_VERSION, // 当前运行的版本时间戳
    platform: getPlatform() === 'pc' ? 'web' : 'h5'
  }
});

// 启用自动错误捕获
const errorCapture = new ErrorCapture(tracker);
// 现在所有的JavaScript错误、Promise错误、资源加载错误都会自动上报
// 重写console.error，保证三方库的日志也能上报
const originalError = console.error;
console.error = (...args) => {
  originalError.apply(console, args);
  tracker.sendError({
    message: '#ERROR#错误信息',
    content: args,
    ...(myJsTools.getItem("docUserInfo")?.docName ? { docName: myJsTools.getItem("docUserInfo")?.docName } : {})
  });
}

// 挂载为全局变量与实例属性
// 组件内可通过 this.$tracker 访问，全局可通过 window.$tracker 访问
;(Vue as any).prototype.$tracker = tracker
;(window as any).$tracker = tracker

// store.watch(
//   (state) => state.isLogin, // 这里替换成你要监控的数据
//   (newValue, oldValue) => {
//     console.log('数据变化了 main.ts', newValue, oldValue);
//     console.log(myJsTools.getItem('docAllInfo'));
//     console.log(myJsTools.getItem('tencentInfo'));
//     if (newValue && newValue == 1) {
//       const userID = myJsTools.getItem('tencentInfo')?.userID;
//       const userSig = myJsTools.getItem('tencentInfo')?.userSig;
//       const SDKAppID = myJsTools.getItem('tencentInfo')?.SDKAppID;
//       TUILogin.login({
//         SDKAppID: SDKAppID,
//         userID: userID,
//         userSig: userSig,
//         useUploadPlugin: true,
//         framework,
//       }).then((res) => {
//         stopLoading()
//         console.log('TUILogin登录成功', res);
//       })
//     .catch((error) => { 
//     console.log('TUILoginerror',error);
//     })
//     } else {
//       console.log('进来了 进来了');
      
//       TUILogin.logout()
//     }
//     // 在这里执行你想执行的代码
//   },
//   { deep: true } // 如果是对象或数组，需要设置为deep: true
// );

// Vue.prototype.global = global;
Vue.use(Vant)
  .use(Lazyload)
  .use(LightTimeline)
  .use(vueFingerDirective).use(less);
Vue.config.productionTip = false
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
